import styled from 'styled-components'

export const Container = styled.div`
    padding: 40px 0 100px;
    font-size: 2rem;
    font-weight: 700;

    p {
        margin: 0;
        max-width: 900px;
        text-align: center;
        line-height: 1.2;
    }

    a {
        text-decoration: inherit;
        color: inherit;
    }

    .search-box {
        min-height: 320px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .search {
            width: 800px;
            max-width: 90%;
        }
    }
`

export const ItemBox = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 1.3rem;
    max-width: 95%;
    margin: auto;
`

export const Item = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    height: 130px;
    padding: 20px 0 10px;
    margin: 10px;
    border: 1px solid rgba(0,0,0,.18);
    box-shadow: 0 4px 3px -3px rgba(0,0,0,.2);
    border-radius: 6px;
    transition: 0.2s;
    background-color: white;
    user-select: none;
    cursor: pointer;

    &:hover {
        box-shadow: 0 15px 15px -10px rgba(0,0,0,.18);
        transform: translate(0px, -5px);
        border: 1px solid rgba(0,0,0,.25);
    }
`
